import { useRecordContext } from 'react-admin';
import { Link } from "@material-ui/core";

const FountainURLField = ( props: any ) => {
    const record = useRecordContext(props);
    const value = record && record['cosmos_data'] && record['cosmos_data']['fountain_id'];

    if (value == null || value == undefined) {
        return null;
    }

    return (
      <Link
        href={`https://app.fountain.com/gopuff/applicants?applicantId=${value}&page=1&per_page=20&persistedPopupType=applicantDrawerPopup`}
        variant='body2'
        target="_blank">{value}</Link>
    );
};

FountainURLField.defaultProps = {
  addLabel: true,
}

export default FountainURLField;